export default __webpack_public_path__ + "d6fbe1bd7583d88bad9d03e01b0aba8e.png";